import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import { registerUser } from '../actions/authentication';
import classnames from 'classnames';
import { Button, Input, InputGroup } from 'rsuite';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';

class Register extends Component {

    constructor() {
        super();
        this.state = {
            name: '',
            email: '',
            password: '',
            password_confirm: '',
            passwordVisible: false,
            organizations: ['63b4482766d52eb74d471210', '63b454d563887f3e4fc74a2a'],
            errors: {}
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePasswordVisible = this.handlePasswordVisible.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(n, v ) {
        this.setState({
            [n]: v
        })
    }

    handlePasswordVisible(e) {
      const s = parseInt(e.currentTarget.getAttribute('state'));
      let v = false;
      if (s === 0) {
        v = true;
      }
      this.setState({
        passwordVisible: v
      })
    }

    handleSubmit(e) {
        e.preventDefault();
        const user = {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            password_confirm: this.state.password_confirm,
            organizations: this.state.organizations,
        }
        this.props.registerUser(user, this.props.history);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.auth.isAuthenticated) {
            this.props.history.push('/')
        }
        if(nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
    }

    componentDidMount() {
        if(this.props.auth.isAuthenticated) {
            this.props.history.push('/');
        }
    }

    render() {
        const { errors } = this.state;
        return(
        <div className="container" style={{ marginTop: '50px', width: '700px'}}>
            <h2 style={{marginBottom: '40px'}}>Registration</h2>
            <form onSubmit={ this.handleSubmit }>
                <div className="form-group">
                    <Input
                    type="text"
                    placeholder="Name"
                    autoComplete="name"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.name
                    })}
                    name="name"
                    onChange={value => {
                      this.handleInputChange('name', value);
                    }}
                    value={ this.state.name }
                    />
                    {errors.name && (<div className="invalid-feedback">{errors.name}</div>)}
                </div>
                <div className="form-group">
                    <Input
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.email
                    })}
                    name="email"
                    onChange={value => {
                      this.handleInputChange('email', value);
                    }}
                    value={ this.state.email }
                    />
                    {errors.email && (<div className="invalid-feedback">{errors.email}</div>)}
                </div>
                <div className="form-group">
                  <InputGroup inside>
                    <Input
                    type={this.state.passwordVisible ? 'text' : 'password'}
                    placeholder="Password"
                    autoComplete="current-password"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.password
                    })}
                    name="password"
                    onChange={value => {
                      this.handleInputChange('password', value);
                    }}
                    value={ this.state.password }
                    />
                    {errors.password && (<div className="invalid-feedback">{errors.password}</div>)}
                    <InputGroup.Button state={this.state.passwordVisible ? 1 : 0} onClick={this.handlePasswordVisible}>
                      {this.state.passwordVisible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                </div>
                <div className="form-group">
                  <InputGroup inside>
                    <Input
                    type={this.state.passwordVisible ? 'text' : 'password'}
                    placeholder="Confirm Password"
                    autoComplete="current-password"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.password_confirm
                    })}
                    name="password_confirm"
                    onChange={value => {
                      this.handleInputChange('password_confirm', value);
                    }}
                    value={ this.state.password_confirm }
                    />
                    {errors.password_confirm && (<div className="invalid-feedback">{errors.password_confirm}</div>)}
                    <InputGroup.Button state={this.state.passwordVisible ? 1 : 0} onClick={this.handlePasswordVisible}>
                      {this.state.passwordVisible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                </div>
                <div className="form-group">
                    <Button size="lg" appearance="primary" type="submit" className="btn btn-primary iron-button">
                        Register User
                    </Button>
                </div>
            </form>
        </div>
        )
    }
}

Register.propTypes = {
    registerUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps,{ registerUser })(withRouter(Register))
